{
  "$schema": "./skinning_variables.schema.json",
  "### This JSON keeps the default style properties for the gridscale light skin.": "",
  "### The properties you define here, will be available in dasherized/kebap-case format as CSS properties in the panels.": "",
  "### As values you can defined fixed values, property names also defined in this file and several sass functions (use existing code for example)": "",
  "### Also you can add comments by prepending '###' to the property key (like this line)": "",
  "### properties starting with underscore (_) will be PRIVATE which means they are NOT exposed as CSS properties. They are only for inheritence": "",
  "### REMEMBER: That all variables MUST be present in `skinConfigObj` in skinconfig.model.ts file - in snake_case! Even the private ones !!!!": "",
  "_darkGrey": "#333333",
  "_mediumGrey": "#666666",
  "_lightGrey": "#999999",
  "_mediumGreyOutline": "#d8d8d8",
  "_mediumGreyBackground": "#f0f0f0",
  "_lightGreyBackground": "#f7f7f7",
  "_clickareaBgHighlight": "$secondaryColor",
  "_clickareaBgHover": {
    "sass-function": "adjust-hsl",
    "sass-function-args": [
      "$_clickareaBgHighlight",
      "$saturation: 38",
      "$lightness: 92"
    ]
  },
  "darkModeColorIntensity": "80",
  "primaryColor": "#15425f",
  "primaryTextColor": "#FFFFFF",
  "darkModeColor": "$primaryColor",
  "darkModeCtaButtonBackgroundColor": "$accentColor",
  "primaryColorDarker20": {
    "sass-function": "color.scale",
    "sass-function-args": [
      "$primaryColor",
      "$lightness: -20%"
    ]
  },
  "primaryColorRgba10": {
    "sass-function": "rgba",
    "sass-function-args": [
      "$primaryColor",
      0.1
    ]
  },
  "primaryColorRgba20": {
    "sass-function": "rgba",
    "sass-function-args": [
      "$primaryColor",
      0.2
    ]
  },
  "primaryColorRgba30": {
    "sass-function": "rgba",
    "sass-function-args": [
      "$primaryColor",
      0.3
    ]
  },
  "primaryColorRgba40": {
    "sass-function": "rgba",
    "sass-function-args": [
      "$primaryColor",
      0.4
    ]
  },
  "primaryColorRgba50": {
    "sass-function": "rgba",
    "sass-function-args": [
      "$primaryColor",
      0.5
    ]
  },
  "primaryColorRgba60": {
    "sass-function": "rgba",
    "sass-function-args": [
      "$primaryColor",
      0.6
    ]
  },
  "primaryColorRgba70": {
    "sass-function": "rgba",
    "sass-function-args": [
      "$primaryColor",
      0.7
    ]
  },
  "primaryColorRgba80": {
    "sass-function": "rgba",
    "sass-function-args": [
      "$primaryColor",
      0.8
    ]
  },
  "primaryColorRgba90": {
    "sass-function": "rgba",
    "sass-function-args": [
      "$primaryColor",
      0.9
    ]
  },
  "primaryColorHover": {
    "sass-function": "color.scale",
    "sass-function-args": [
      "$primaryColor",
      "$lightness: -20%"
    ]
  },
  "primaryDarkColor": {
    "sass-function": "color.scale",
    "sass-function-args": [
      "$primaryColor",
      "$lightness: -50%"
    ]
  },
  "primaryDarkerColor": {
    "sass-function": "color.scale",
    "sass-function-args": [
      "$primaryColor",
      "$lightness: -80%"
    ]
  },
  "dimmerBackdropFilter": "blur(4px)",
  "dimmerColor": "rgba(15, 34, 46, 0.4)",
  "igColorWhite": "#ffffff",
  "igColorWhite80": {
    "sass-function": "rgba",
    "sass-function-args": [
      "$igColorWhite",
      0.8
    ]
  },
  "igColorWhite40": {
    "sass-function": "rgba",
    "sass-function-args": [
      "$igColorWhite",
      0.4
    ]
  },
  "igColorWhite30": {
    "sass-function": "rgba",
    "sass-function-args": [
      "$igColorWhite",
      0.3
    ]
  },
  "igTextColor": "#495057",
  "igColorText": "$igTextColor",
  "igColorTextDarker": "$_darkGrey",
  "igColorLabel": "$_mediumGrey",
  "igColorLabel2": "$_mediumGrey",
  "igColorLabelLight": "$_lightGrey",
  "igColorBoxShadow": "#b4b4b4",
  "igColorBlack": "#000000",
  "secondaryColor": "#2e83a0",
  "accentColor": "#5ec03e",
  "headlinesColor": "$secondaryColor",
  "h1Color": "$headlinesColor",
  "h2Color": "$headlinesColor",
  "h3Color": "$headlinesColor",
  "h4Color": "$headlinesColor",
  "h5Color": "#333333",
  "h6Color": "#333333",
  "roundedIconColorActive": "#FFFFFF",
  "roundedIconBackgroundActive": "$primaryColor",
  "roundedIconColorInactive": "$primaryColor",
  "roundedIconBackgroundInactive": "#F0F0F0",
  "inputCheckboxBorder": "$_lightGrey",
  "inputFormBorder": "$_mediumGreyOutline",
  "buttonColor": "$secondaryColor",
  "buttonColorDisabled": "#CCCCCC",
  "buttonColorDisableOverlay": "#f0f0f0",
  "buttonHoverColor": {
    "sass-function": "color.scale",
    "sass-function-args": [
      "$buttonColor",
      "$lightness: -20%"
    ]
  },
  "ctaButtonBackgroundColor": "$accentColor",
  "ctaButtonBackgroundColorHover": {
    "sass-function": "color.scale",
    "sass-function-args": [
      "$ctaButtonBackgroundColor",
      "$lightness: -20%"
    ]
  },
  "ctaButtonBackgroundColorDisabled": {
    "sass-function": "rgba",
    "sass-function-args": [
      "$ctaButtonBackgroundColor",
      "0.2"
    ]
  },
  "ctaButtonColor": "#FFFFFF",
  "headerBackgroundColor": "$primaryColor",
  "headerFormColor": "#FFFFFF",
  "headerFormBackgroundColor": "$primaryColor",
  "headerFormPlaceholderColor": {
    "sass-function": "rgba",
    "sass-function-args": [
      "$headerFormColor",
      0.4
    ]
  },
  "tableHeaderBackgroundColor": "$headerBackgroundColor",
  "tableHeaderBorderColor": "$headerFormPlaceholderColor",
  "tableHeaderCheckboxBorderColor": "#a5b4c0",
  "tableHeaderFontColor": "$headerFormColor",
  "tableCellActionIconColor": "#999999",
  "tableCellBackgroundColor": "#FFFFFF",
  "tableCellBackgroundColorHover": "$tableCellBackgroundColor",
  "tableCellModalBackgroundColor": "$tableCellBackgroundColor",
  "tableCellModalBackgroundColorHover": "#f0f0f0",
  "tableCellForegroundColor": "$textSecondaryColor",
  "tableCellLinkForegroundColor": "$secondaryColor",
  "tableCellBorderDefault": "$_mediumGreyBackground",
  "tableCellBorderGroup": "#cccccc",
  "tableSelectedActionsLinkColor": "$_darkGrey",
  "tableSelectedActionsHoverBackgroundcolor": "$_mediumGreyBackground",
  "tableSelectedActionsLabel": "$_mediumGrey",
  "skinFontFamily": "Roboto",
  "skinFontFamilyHeadline": "Roboto",
  "logoData": "transparent",
  "logoWidth": "200",
  "logoDarkData": "transparent",
  "logoDarkWidth": "200px",
  "backgroundData": "$primaryColor",
  "backgroundSize": "cover",
  "colorRed": "#e50000",
  "colorOrange": "#e58800",
  "priceboxColorBackground": "$primaryColor",
  "priceboxColor": "#FFFFFF",
  "priceboxBorderColor": "$igColorWhite40",
  "priceBoxButtonBackground": "$ctaButtonBackgroundColor",
  "priceBoxButtonBackgroundHover": {
    "sass-function": "color.scale",
    "sass-function-args": [
      "$priceBoxButtonBackground",
      "$lightness: -20%"
    ]
  },
  "priceBoxButtonBackgroundDisabled": {
    "sass-function": "rgba",
    "sass-function-args": [
      "$priceBoxButtonBackground",
      "0.2"
    ]
  },
  "iconsColor": "$secondaryColor",
  "iconsDarkerColor": {
    "sass-function": "color.scale",
    "sass-function-args": [
      "$iconsColor",
      "$lightness: -50%"
    ]
  },
  "linkColor": "$iconsColor",
  "linkColorHover": "$iconsDarkerColor",
  "loginIconHeadlineColor": "$primaryColor",
  "loginButtonColor": "$secondaryColor",
  "textSecondaryColor": "#666666",
  "igBoxShadow": "0 0 6px #0000004d",
  "igBoxShadowColor": "#0000004d",
  "igBoxShadowBlur": "6px",
  "boxShadow": "$igBoxShadow",
  "boxGlow": "0 1px 4px 0 rgba(0, 0, 0, 0.3), 0 0 10px 0 rgba(0, 0, 0, 0.05), inset 0 0 5px 0 rgba(0, 0, 0, 0.05)",
  "igColorCardBackground": "#FFFFFF",
  "igColorCardBackgroundHover": "$_lightGreyBackground",
  "igColorCardBorder": "$_mediumGreyBackground",
  "igColorCardLabel": "$_mediumGrey",
  "igColorDashboardConnectionLines": "$_mediumGrey",
  "igColorDashboardObjectNames": "$primaryColor",
  "igColorDetailsHeaderHeadline": "$secondaryColor",
  "igColorEmptyStateAddButtonBackground": "$secondaryColor",
  "igColorEmptyStateAddButtonForeground": "#FFFFFF",
  "igColorFormClickareaBackground": "$_mediumGreyBackground",
  "igColorFormClickareaBackgroundHover": "$_clickareaBgHover",
  "igColorFormClickareaBackgroundHighlight": "$_clickareaBgHighlight",
  "igColorFormClickareaForegroundBold": "$_darkGrey",
  "igColorFormClickareaForegroundBoldHighlight": "#FFFFFF",
  "igColorFormClickareaForegroundLight": "#585858",
  "igColorFormClickareaForegroundLightHighlight": "#FFFFFF",
  "igColorFormDropdownSelected": "#666666",
  "igColorFormDropdownPlaceholder": "#CCCCCC",
  "igColorFormInputBackground": "transparent",
  "igColorFormInputForeground": "$igTextColor",
  "igColorFormInputSwitchBackgroundOff": "#d8d8d8",
  "igColorFormInputSwitchHandleOff": "#ffffff",
  "igColorFormInputSwitchBackgroundOn": "$iconsColor",
  "igColorFormInputSwitchHandleOn": "#FFFFFF",
  "igColorFormLabelColor": "$secondaryColor",
  "igColorHeaderBorders": {
    "sass-function": "rgba",
    "sass-function-args": [
      "$headerFormColor",
      0.4
    ]
  },
  "igColorHeaderIconBackground": "$headerFormColor",
  "igColorHeaderIconForeground": "$headerFormBackgroundColor",
  "igColorOverlayAlertCloseButtonBackground": {
    "sass-function": "rgba",
    "sass-function-args": [
      "#FFFFFF",
      0.5
    ]
  },
  "igColorOverlayAlertCloseButtonForeground": "$primaryColor",
  "igColorOverlayAlertDimmer": "rgba(39, 62, 76, .6)",
  "igColorOverlayAlertMessage": "$_mediumGrey",
  "igColorPriceTableBorder": "#e3e3e3",
  "igColorListValue": "#333333",
  "igColorPriceTableForeground": "$_mediumGrey",
  "igColorPriceTableForegroundBold": "$_darkGrey",
  "igColorPriceTableHeaderBackground": "#f7f7f7",
  "igColorPriceTableHeaderForeground": "#333333",
  "igColorPriceListHeaderBackground": "#f0f0f0",
  "igColorPriceListHeaderForeground": "#666666",
  "igColorPriceListHeaderForegroundBold": "#333333",
  "igColorStatusGrey": "#b4b4b4",
  "igColorTooltipBackground": "#333333",
  "igColorTooltipForeground": "#FFFFFF",
  "igColorTooltipShadow": "rgba(0, 0, 0, 0.3)",
  "igColorViewportBackground": "#F8F8F8",
  "igColorMidnightBlue": "#15425f",
  "igColorMediumBlue": "#2e83a0",
  "igColorMediumBlue60": "#82b5c6",
  "igColorMediumBlue40": "#abcdd9",
  "igColorMediumBlue20": "#cfe0e6",
  "igColorMediumBlueHover": "#1d6983",
  "igColorMenuBackground": "$igColorWhite",
  "igColorMenuBackgroundHighlight": "$_clickareaBgHighlight",
  "igColorMenuBackgroundHover": "#f0f0f0",
  "igColorMenuBackgroundProjectSwitchHover": "#f0f0f0",
  "igColorMenuForeground": "$_darkGrey",
  "igColorMenuForegroundHighlight": "#FFFFFF",
  "igColorMenuForegroundLight": "$_mediumGrey",
  "igColorSkyBlue": "#6bb7c4",
  "igColorSkyBlue60": "#a6d4dc",
  "igColorSkyBlue40": "#c4e2e7",
  "igColorSkyBlue20": "#dbeaed",
  "igColorSkyBlueHover": "#4599a8",
  "igColorLightBlue": "#92d2db",
  "igColorCoralRed": "#ff766a",
  "igColorCoralRed60": "#ffada6",
  "igColorCoralRed40": "#ffc8c3",
  "igColorCoralRedHover": "#e35a4e",
  "igColorWarningRed": "#c53538",
  "igColorWarningRed40": {
    "sass-function": "rgba",
    "sass-function-args": [
      "$igColorWarningRed",
      0.4
    ]
  },
  "igColorWarningRedLight": "#ffe4e1",
  "igColorHintOrange": "#ffae4a",
  "igColorHintOrange40": {
    "sass-function": "rgba",
    "sass-function-args": [
      "$igColorHintOrange",
      0.4
    ]
  },
  "igColorSuccessGreen": "#5ec03e",
  "igColorSuccessGreen40": {
    "sass-function": "rgba",
    "sass-function-args": [
      "$igColorSuccessGreen",
      0.4
    ]
  },
  "igColorSuccessGreenLight": "#ddfad5",
  "igColorSuccessGreenHover": "#178e3f",
  "igColorNoteYellow": "#fffac6",
  "igColorAlertErrorBackground": "$igColorWarningRedLight",
  "igColorAlertErrorForeground": "$igColorWarningRed",
  "igColorAlertWarningBackground": "$igColorNoteYellow",
  "igColorAlertWarningForeground": "$igColorWarningRed",
  "igColorAlertSuccessBackground": "$igColorSuccessGreenLight",
  "igColorAlertSuccessForeground": "$igColorSuccessGreenHover",
  "igColorAlertInfoBackground": "$_mediumGreyBackground",
  "igColorAlertInfoForeground": "$igTextColor",
  "igColorPitchBlack": "#000000",
  "igColorMainMenuBackground": "#FFFFFF",
  "igColorMainMenuForeground": "$primaryColor",
  "igColorMainMenuActiveBackground": "$_mediumGreyBackground",
  "igColorMainMenuActiveForeground": "$primaryColor",
  "igColorMainMenuHoverBackground": "$_clickareaBgHover",
  "igColorSideMenuBackground": "transparent",
  "igColorSideMenuForeground": "$igColorMainMenuForeground",
  "igColorSideMenuActiveBackground": "$igColorWhite",
  "igColorSideMenuActiveForeground": "$igColorMainMenuActiveForeground",
  "igColorSideMenuHoverBackground": "$igColorMainMenuHoverBackground",
  "igColorAccordionHeaderBackground": "#FFFFFF",
  "igColorAccordionHeaderForeground": "#666666",
  "igColorAccordionHeaderHoverBackground": "$igColorWhite",
  "igColorAccordionHeaderActiveBackground": "#FFFFFF",
  "igColorAccordionHeaderActiveForeground": "#666666",
  "igColorHelpcenterBulletBackground": "#eeeeee",
  "igColorHelpcenterBulletForeground": "#333333",
  "igColorHelpcenterHeaderGradientFrom": "$primaryColor",
  "igColorHelpcenterHeaderGradientTo": "$secondaryColor",
  "igColorProgressbarBackground": "#e3e3e3",
  "igColorChecklistGreenBackground": "$igColorSuccessGreen",
  "igColorChecklistGreenForeground": "#FFFFFF",
  "igColorEmptystateIcon": "#356781",
  "igColorEmptystateText": "$_mediumGrey",
  "igColorMoreIconForeground": "$_mediumGrey",
  "igColorMoreIconHoverBackground": "$_lightGreyBackground",
  "igColorMoreIconHoverForeground": "$_darkGrey",
  "igColorFormInputPlaceholderForeground": "$igColorFormClickareaForegroundLight",
  "igColorDropdownGroupHeaderBackground": "transparent",
  "igColorDropdownGroupHeaderForeground": "$_lightGrey",
  "igColorDesignerPreviewOutline": "transparent",
  "igColorHotspot": "$igColorHintOrange",
  "igMenuOverlayBoxShadow": "$igBoxShadow",
  "igColorBreadcrumbForeground": "$_lightGrey",
  "checklistButtonBackground": "$primaryColor",
  "checklistButtonHoverBorderColor": "#abcdd9",
  "igColorBillingInvoiceInfoForeground": "#666666",
  "highContrastBorderWidth": "0",
  "highContrastBorderStyle": "none",
  "highContrastBorderColor": "transparent",
  "highContrastBorder": "none"
}
